import React, { useEffect, useState } from "react";
import { usePlacesWidget } from "react-google-autocomplete";
import { useController } from "react-hook-form";

import { StyledLocation } from "./location.style";

const Location = ({
  control,
  name,
  latlongfield,
  required,
  placeholder,
  readOnly,
  error,
}) => {
  const { field } = useController({
    name,
    control,
    rules: {
      required: {
        value: required,
        message: "This field is required",
      },
    },
  });
  const { field: field1 } = useController({
    name: latlongfield,
    control,
    rules: {
      required: {
        value: required,
        message: "This field is required",
      },
    },
  });
  const [selectedPlace, setSelectedPlace] = useState(field.value || "");
  const [selectedGeoLocation, setSelectedGeoLocation] = useState(
    field1.value || "",
  );

  const { ref } = usePlacesWidget({
    apiKey: "AIzaSyCbh6vQ_puMJMACFR7PnJj1qMW6Ea-CksI",
    onPlaceSelected: (place) => {
      setSelectedPlace(place.formatted_address);
      setSelectedGeoLocation(
        `${place.geometry.location.lat()},${place.geometry.location.lng()}`,
      );
    },
  });

  useEffect(() => {
    field1.onChange(selectedGeoLocation);
  }, [selectedGeoLocation]);

  useEffect(() => {
    field.onChange(selectedPlace);
  }, [selectedPlace]);

  return (
    <StyledLocation error={error ? 1 : 0}>
      <input
        type="text"
        ref={ref}
        placeholder={placeholder}
        readOnly={readOnly}
      />
      <input
        type="hidden"
        value={selectedPlace}
        onBlur={field.onBlur}
        name={field.name}
        ref={field.ref}
      />
      <input
        type="hidden"
        value={selectedGeoLocation}
        onBlur={field1.onBlur}
        name={field1.name}
        ref={field1.ref}
      />
      <span className="error">{error?.message || ""}</span>
    </StyledLocation>
  );
};

export default Location;
